// extracted by mini-css-extract-plugin
module.exports = {"ButtonDropdownItem":"button-dropdown-item_ButtonDropdownItem__LAqWG typography_bodyFont__Sn75r","disabled":"button-dropdown-item_disabled__pT9WN"};